<template>
  <v-card outlined class="pa-4 b2c-v2-kpi-card" :class="{ 'kpi-inverse': inverse, 'kpi-main': main }" height="100%">
    <div class="pw-label">{{ label }}</div>
    <div v-if="loading" class="pw-kpi pw-num grey--text">—</div>
    <div
      v-else
      class="pw-kpi pw-num"
      :class="{ 'kpi-link': clickable }"
      :role="clickable ? 'button' : null"
      :tabindex="clickable ? 0 : null"
      @click="select"
      @keydown.enter="select"
    >
      {{ formatted }}
    </div>
    <div v-if="!loading && details.length" class="caption kpi-details mt-1">
      <span v-for="(d, i) in details" :key="d.label">
        {{ d.label }} {{ d.value }}<span v-if="i < details.length - 1"> · </span>
      </span>
    </div>
  </v-card>
</template>

<script>
import { formatNumber } from '@/utils/b2c-report.utils';

export default {
  name: 'B2CV2KpiCard',
  props: {
    label: { type: String, required: true },
    value: { type: Number, default: 0 },
    // 'count' para cantidades, 'usd' para MRR
    valueType: { type: String, default: 'count' },
    // Desglose bajo la cifra: [{ label, value }] con el valor ya formateado
    details: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
    // Caja principal: cifra más grande.
    main: { type: Boolean, default: false },
    // Contraste invertido: fondo azul, texto blanco (caja BCI).
    inverse: { type: Boolean, default: false }
  },
  computed: {
    formatted() {
      return this.valueType === 'usd' ? `USD ${formatNumber(this.value)}` : formatNumber(this.value);
    }
  },
  methods: {
    select() {
      if (this.clickable) this.$emit('select');
    }
  }
};
</script>

<style scoped>
.kpi-link {
  cursor: pointer;
  color: var(--pw-link);
  text-decoration: underline;
  text-underline-offset: 4px;
}

.kpi-details {
  color: var(--pw-text-muted);
}

.kpi-main .pw-kpi {
  font-size: 34px;
}

.kpi-inverse {
  background: var(--pw-primary);
  border-color: var(--pw-primary);
}

.kpi-inverse .pw-label,
.kpi-inverse .pw-kpi,
.kpi-inverse .kpi-link,
.kpi-inverse .kpi-details {
  color: var(--pw-surface);
}
</style>
